import { Footer } from '@/components/Footer'
import { PublicNavbar } from '@/components/PublicNavbar'
import './style.css'

export const Impressum: React.FC = () => (
  <div>
    <PublicNavbar lightBg />
    <div className="public-page">
      <h2 className="title">Impressum</h2>
      <div>
        <p>Partizi UG (haftungsbeschränkt)</p>
        <p>Ostendorfer Straße 13a</p>
        <p className="mb-4">27726 Worpswede</p>
        <p>
          E-Mail: <a href="mailto:Team@Partizi.de">Team@Partizi.de</a>
        </p>
        <p className="mb-4">Telefon: +49 (0) 2224 123 6666</p>
        <p className="mb-4">Geschäftsführer: Frederick Lüders</p>
        <p className="mb-4">
          Eingetragen beim Amtsgericht Walsrode, HRB 207675
        </p>
        <p className="mb-4">Umsatzsteueridentifikationsnummer: DE 325526455</p>
        <p>
          Plattform der EU-Kommission zur Online-Streitbeilegung in
          Verbraucherangelegenheiten:
        </p>
        <p>
          <a
            href={'http://ec.europa.eu/consumers/odr/'}
            target="_blank"
            rel="noopener noreferrer"
          >
            http://ec.europa.eu/consumers/odr/
          </a>
        </p>
      </div>
      <div>
        <h3 className="section-title">Haftung für Inhalte</h3>
        <p className="mb-4">
          Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte
          auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
          §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
          verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
          überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
          Tätigkeit hinweisen.
        </p>
        <p>
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
          Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
          Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
          Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden
          von entsprechenden Rechtsverletzungen werden wir diese Inhalte
          umgehend entfernen.
        </p>
      </div>
      <div>
        <h3 className="section-title">Haftung für Links</h3>
        <p className="mb-4">
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren
          Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
          fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
          verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
          Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
          Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige
          Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
        </p>
        <p>
          Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch
          ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
          Bekanntwerden von Rechtsverletzungen werden wir derartige Links
          umgehend entfernen.
        </p>
      </div>
      <div>
        <h3 className="section-title">Urheberrecht</h3>
        <p className="mb-4">
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
          Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
          Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
          Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
          jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite
          sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
        </p>
        <p>
          Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt
          wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden
          Inhalte Dritter als solche gekennzeichnet. Solltest Du trotzdem auf
          eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
          entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
          werden wir derartige Inhalte umgehend entfernen.
        </p>
      </div>
    </div>
    <Footer />
  </div>
)
